import React, { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";

import useCompanies from "../../hooks/useCompanies";
import useAuth from "../../hooks/useAuth";

import Screen from "../../components/Screen";

import Checklist from "./Checklist";
import Support from "./Support";
import Edit from "./Edit";
import Header from "./Header";
import Navbar from "./Navbar";
import Overview from "./Overview";
import Permissions from "./Permissions";
import Comments from "./comments";
import ProfileEmails from "./ProfileEmails";
import useSubscription from "../../hooks/useSubscription";
import Report from "./report";
import resolveCompanyId from "../../utils/resolveCompanyId";

const tabFromQueryParam = (value) => {
  if (!value) return null;
  const tabId = value.startsWith("#") ? value.slice(1) : value;
  return `#${tabId}`;
};

const Profile = () => {
  const [query] = useSearchParams();
  const location = useLocation();
  const { user, onUser, isManager, isCompany, isAdmin, isCompanyAdmin, isFellowAdmin } = useAuth();
  const {
    loading,
    data,
    addLoading,
    branches,
    setData,
    fetchCompanyById,
    changeCompany,
    changeBranch,
    tab,
    setTab,
    changeCompanyReport,
    reportLoading,
    fetchBranches
  } = useCompanies();
  const [nature, setNature] = useState(data?.nature?.name);
  const { getData } = useSubscription()
  const companyID = query.get("companyID");
  const branchID = query.get("branchID");
  const company = branchID
    ? isManager
      ? user?.companyID
      : user
    : isManager
      ? user?.companyID
      : data;
  useEffect(() => {
    if (isManager) onUser();
    else if (!branchID) fetchCompanyById(companyID);
  }, [query]);
  useEffect(() => {
    if (isAdmin) getData()
  }, [])

  useEffect(() => {
    if (isManager) {
      setData(branches[0]);
      fetchBranches(resolveCompanyId(user?.companyID), branchID);
    }
    if (branchID) {
      setData(branches?.find((item) => item._id == branchID));
    }
  }, []);

  useEffect(() => {
    const currentTab = tabFromQueryParam(query.get("current_tab"));
    if (currentTab) {
      setTab(currentTab);
      return;
    }
    if (location.state?.tab) {
      setTab("#profile-support");
      return;
    }
    setTab((activeTab) => activeTab || "#profile-overview");
  }, [query]);

  return (
    <Screen
      loading={loading}
      faqsId={"profile"}
      flow={[
        {
          label: branchID
            ? "Sites"
            : (isCompany && !branchID) || isManager
              ? "Profile"
              : "Companies",
          to: branchID ? "/branches" : "/companies",
        },
        { label: "Home", to: "/" },
        (isCompany && !branchID) || isManager
          ? null
          : {
            label: branchID ? "Sites" : "Companies",
            to: branchID ? "/branches" : "/companies",
          },
        {
          label: branchID || isManager ? "Site Profile" : "Company Profile",
          to: "/profile",
        },
      ].filter((item) => item)}
    >
      <section className="section profile">
        <div className="row">
          {branchID ? null : <Header user={company} nature={nature} />}

          <div className={branchID ? "col-xl-12" : "col-xl-8"}>
            <div className="card">
              <div className="card-body pt-3">
                <Navbar
                  tab={tab}
                  setTab={setTab}
                  isAdmin={isAdmin}
                  isCompanyAdmin={isCompanyAdmin}
                  isFellowAdmin={isFellowAdmin}
                  isManager={isManager}
                  branchID={branchID}
                  isCompany={isCompany}
                />
                <div className="tab-content pt-2">
                  <Overview
                    company={company}
                    tab={tab}
                    isManager={isManager}
                    branchID={branchID}
                  />
                  <Edit
                    data={data}
                    setData={setData}
                    tab={tab}
                    onSubmit={() => {
                      isManager || branchID
                        ? changeBranch(branchID ? company?._id : companyID)
                        : changeCompany();
                    }}
                    loading={addLoading}
                    isManager={isManager}
                    branchID={branchID}
                    isAdmin={isAdmin}
                  />
                  {isCompany && (
                    <Report
                      data={data}
                      setData={setData}
                      tab={tab}
                      onSubmit={() => changeCompanyReport()}
                      loading={reportLoading}
                    />
                  )}
                  <Checklist company={company} tab={tab} branchID={branchID} />
                  <ProfileEmails
                    company={company}
                    tab={tab}
                    isManager={isManager}
                    branchID={branchID}
                  />
                  <Support
                    company={company}
                    tab={tab}
                    isManager={isManager}
                    isCompany={isCompany}
                    isAdmin={isAdmin}
                  />
                  <Permissions company={company} branchID={branchID} tab={tab} />
                  {isAdmin || (isCompany && <Comments company={company} tab={tab} />)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Screen>
  );
};

export default Profile;
